module.exports = __webpack_public_path__ + "img/bg.ec1b85ca.jpg";